import { runInAction } from 'mobx'

import { IPermitTypeField, PermitFieldType } from '~/client/graph'

import PermitField from '../models/PermitField'
import Workflow from '../models/Workflow'
import BsonObjectId from './BsonObjectId'
import { clearSnapshotUrls } from './locationSnapshot'
import { copyObjectDeep } from './util'

const INHERITABLE_FIELD_TYPES: PermitFieldType[] = [
  PermitFieldType.Location,
  PermitFieldType.Company,
  PermitFieldType.Requester,
  PermitFieldType.Assignee,
  PermitFieldType.Subscriber,
  PermitFieldType.Equipment,
  PermitFieldType.Material,
]

export function applyParentFieldDefaults(
  childPermit: Workflow,
  parentPermit: Workflow,
  childTemplateFields: IPermitTypeField[],
): void {
  if (!childPermit || !parentPermit) return

  runInAction(() => {
    // StartFinishDates are stored directly on SitePermit, not in the fields array
    if (parentPermit.startDate && parentPermit.endDate) {
      childPermit.startDate = parentPermit.startDate
      childPermit.endDate = parentPermit.endDate
      childPermit.isAllDay = parentPermit.isAllDay
    }

    for (const fieldType of INHERITABLE_FIELD_TYPES) {
      const parentField = parentPermit.fields.find(f => f.type === fieldType)
      if (!parentField) continue

      const childTemplateField = childTemplateFields.find(
        f => f.type === fieldType,
      )
      if (!childTemplateField) continue

      let childField = childPermit.fields.find(f => f.type === fieldType)

      if (!childField) {
        childField = new PermitField(
          BsonObjectId.generate(),
          childTemplateField.id,
          fieldType,
        )
        childPermit.fields.push(childField)
      }

      const copiedValues = copyObjectDeep<any[]>(parentField.values)
      // Report snapshots belong to the parent's save — a linked child saves
      // headlessly (no capture mounts), so inherited URLs would persist
      // another workflow's images forever.
      copiedValues.forEach(value => clearSnapshotUrls(value))
      childField.values =
        !childTemplateField.isMultiple && copiedValues.length > 1
          ? [copiedValues[0]]
          : copiedValues
    }
  })
}
